import React, { useEffect } from 'react';
import AnnouncementBar from './AnnouncementBar';
import Header from './Header';
import Footer from './Footer';

const LegalPage = ({ title, description, sections }) => {
  useEffect(() => {
    document.title = title;

    let descriptionMeta = document.querySelector('meta[name="description"]');
    if (!descriptionMeta) {
      descriptionMeta = document.createElement('meta');
      descriptionMeta.name = 'description';
      document.head.appendChild(descriptionMeta);
    }
    descriptionMeta.content = description;

    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.name = 'robots';
      document.head.appendChild(robotsMeta);
    }
    robotsMeta.content = 'noindex, nofollow';

    return () => {
      document.title = 'Pronto Notary | Mobile Notary & Apostille Services';
      descriptionMeta.remove();
      robotsMeta.remove();
    };
  }, [description, title]);

  const lastUpdated = new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  }).format(new Date());

  return (
    <div className="min-h-screen bg-cream text-navy">
      <AnnouncementBar />
      <Header />
      <main className="px-6 pb-24 pt-16 md:pb-32 md:pt-24">
        <article className="mx-auto max-w-3xl">
          <header className="mb-14 border-b border-line pb-10">
            <h1 className="font-fraunces text-5xl leading-tight md:text-6xl">
              {title.replace(' | Pronto Notary', '')}
            </h1>
            <p className="mt-5 text-sm italic text-navy/60">
              Last updated {lastUpdated}
            </p>
          </header>

          <div className="space-y-12">
            {sections.map((section) => (
              <section key={section.heading}>
                <h2 className="mb-4 font-fraunces text-2xl text-navy md:text-3xl">
                  {section.heading}
                </h2>
                <p className="text-base leading-8 text-navy/75 md:text-lg">
                  {section.body}
                </p>
              </section>
            ))}
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default LegalPage;